import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService } from '@supoui/core/services/http.service';
import { SupplierInvoice } from '@supoui/shared/model/supplier-invoice';
import { SupplierInvoiceFilterRequest } from '@supoui/economy/models/invoice-filter-request';
import { InvoiceFilterResponse } from '@supoui/economy/models/invoice-filter-response';
import { SeccaInvoiceCount } from '@supoui/economy/models/secca-invoice-count.model';

@Injectable({
  providedIn: 'root'
})
export class SupplierInvoicesService {
  constructor(private httpService: HttpService) {}

  public getInvoices(caseId: string): Observable<SupplierInvoice[]> {
    return this.httpService.get<SupplierInvoice[]>(`services/caseeconomy/api/supplier-invoices/case/${caseId}`);
  }

  public getInvoice(invoiceId: number): Observable<SupplierInvoice> {
    return this.httpService.get<SupplierInvoice>(`services/caseeconomy/api/supplier-invoices/${invoiceId}`);
  }

  public getInvoicesNew(invoiceFilterRequest: SupplierInvoiceFilterRequest): Observable<InvoiceFilterResponse> {
    return this.httpService.post<InvoiceFilterResponse>('services/caseeconomy/api/supplier-invoices/request', invoiceFilterRequest);
  }

  public getInvoicesCount(): Observable<SeccaInvoiceCount> {
    return this.httpService.get<SeccaInvoiceCount>('services/caseeconomy/api/supplier-invoices/count/by-status');
  }
}
